import React from 'react'
import {
  Button as muiButton,
  Box,
  withStyles,
  makeStyles,
  CircularProgress
} from '@material-ui/core'

const useStyles = makeStyles({
  progress: {
    position: 'absolute',
    top: ' 50%',
    left: '50%',
    marginTop: -10,
    marginLeft: -10
  }
})

const StyledButton = withStyles(({ spacing }) => ({
  root: {
    borderRadius: 25,
    padding: spacing(1.5, 7),
    fontSize: '0.87rem'
  }
}))(muiButton)

export default function Button({
  title,
  handleClick,
  disabled = false,
  loading = true
}) {
  const styles = useStyles()
  return (
    <Box position="relative">
      <StyledButton
        disabled={disabled}
        variant="contained"
        color="primary"
        onClick={() => handleClick()}>
        {title}
      </StyledButton>
      {disabled && loading && (
        <CircularProgress size={20} thickness={5} className={styles.progress} />
      )}
    </Box>
  )
}
